import { toast } from 'react-toastify';

const getFolderName = a => {
  switch (a.CODPROCEDI) {
    case 1:
    case 58:
    case 800:
      return 'prontuario';
    case 3:
      return 'ecg';
    case 13:
      return 'stress';
    case 12:
      return 'trans';
    case 4:
      return 'ergo';
    case 6:
    case 820:
      return 'holter';
    case 7:
    case 810:
      return 'mapa';
    case 11:
    case 712:
    case 713:
    case 714:
      return 'eco';
    case 14:
    case 15:
      return 'carotida';
    case 17:
      return 'fetal';
    default:
      return toast.warn('Laudo não disponível para Visualização!');
  }
};

const changeColorConfirma = a => {
  const status =
    a && a.STATUSCONFIRMA ? String(a.STATUSCONFIRMA).toLowerCase() : '';
  const palette = {
    confirmada: {
      backgroundColor: '#03fe31ff',
      color: '#00000fff',
      fontWeight: 'bold',
      borderColor: '#0cea40ff',
    },
    cancelar: {
      backgroundColor: '#dc3545',
      fontWeight: 'bold',
      color: '#fff',
      borderColor: '#dc3545',
    },
    reagendar: {
      backgroundColor: '#ff07d2ff',
      fontWeight: 'bold',
      color: '#fff',
      borderColor: '#ff07d6ff',
    },
    'nr invalido': {
      backgroundColor: '#eaff04ff',
      fontWeight: 'bold',
      color: '#0f0f0fff',
      borderColor: '#eaff04ff',
    },
    'em aberto': {
      backgroundColor: '#2904fdff',
      fontWeight: 'bold',
      color: '#fff',
      borderColor: '#2904fdff',
    },
  };
  return (
    palette[status] || {
      backgroundColor: '#6c757d',
      color: '#fff',
      borderColor: '#6c757d',
    }
  );
};

const getStatusBadgeVariant = (value, field) => {
  const status =
    value != null && value !== '' ? String(value).trim().toLowerCase() : '';
  switch (field) {
    case 'GUIA1':
      if (status === 'sim') return 'success';
      if (status === 'não' || status === 'nao') return 'danger';
      return 'secondary';
    case 'PDF_STATUS':
      if (status === 'enviado') return 'success';
      if (
        status === 'cancelar' ||
        status === 'cancelado' ||
        status === 'cancelada'
      ) {
        return 'danger';
      }
      return 'secondary';
    default:
      return 'secondary';
  }
};

const changeColor = agenda => {
  switch (agenda.SITUACAO || agenda.situacao) {
    case 'Solicitado':
      return { fontWeight: 'bold', backgroundColor: '#00FF00' };
    case 'Autorizado':
      return { fontWeight: 'bold', backgroundColor: '#FFFF00' };
    case 'Marcada':
      return { color: 'black', fontWeight: 'bold', backgroundColor: 'white' };
    case 'Aberta':
      return { color: 'black', backgroundColor: 'white' };
    case 'Atendido':
      return { color: 'blue', fontWeight: 'bold', backgroundColor: 'white' };
    case 'Faltou':
      return {
        textDecoration: 'line-through',
        color: 'green',
        fontWeight: 'bold',
        backgroundColor: 'white',
      };
    case 'Cancelado':
      return {
        textDecoration: 'line-through',
        color: 'red',
        fontWeight: 'bold',
        backgroundColor: 'white',
      };
    case 'Em Atendimento':
      return {
        color: 'purple',
        fontWeight: 'bold',
        backgroundColor: 'white',
      };
    case 'Feriado':
      return { color: 'red', fontWeight: 'bold', backgroundColor: 'white' };
    case 'Reservada':
      return { color: 'brown', fontWeight: 'bold', backgroundColor: 'white' };
    case 'Fechada':
      return {
        color: 'yellow',
        fontWeight: 'bold',
        backgroundColor: 'white',
      };
    case 'Agendada':
      return {
        color: 'green',
        fontWeight: 'bold',
        backgroundColor: 'white',
      };
    default:
      return {
        color: 'black',
        fontWeight: 'bold',
        backgroundColor: 'white',
      };
  }
};

export {
  getFolderName,
  changeColor,
  changeColorConfirma,
  getStatusBadgeVariant,
};
